/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type headerNav_prevUser = {
    readonly user: {
        readonly email: string;
    };
    readonly prevUser: {
        readonly id: string;
    } | null;
    readonly " $refType": "headerNav_prevUser";
};
export type headerNav_prevUser$data = headerNav_prevUser;
export type headerNav_prevUser$key = {
    readonly " $data"?: headerNav_prevUser$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"headerNav_prevUser">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerNav_prevUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "prevUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
(node as any).hash = '8484b279f7a31c5b87375c6f77259d4b';
export default node;
